import React from 'react'
import './EcatalogContent.scss'

import catalogCover from '../../assets/Pictures/catalogCover.png'
import catalogKavir from '../../assets/Pictures/catalogKavirSteel.png'
import catalogCg from '../../assets/Pictures/catalogCoverEP.jpg'

import { Link } from 'react-router-dom'

export default function EcatalogContent() {
  return (
    <div className='ecatalogContent'>
      <div className="container">
        <div className="row">
          <div className="catalog">
              <img src={catalogCover} alt="catalogCover" />
            <div className="catalogContent">
              <div className="catalogContent_top">
                <div className="catalogContent_title">
                  GLOBAL ENERGY INVESTMENT
                </div>
                <div className="catalogContent_subtitle">
                  You can download our product catalog such as Wire 
                  rod, Steel rebar, Galvanized wire, Galvanized products
                  and see details
                </div>
              </div>
              <div className="catalogContent_Button">
                <Link target='_blank' to='https://tfmenu.storage.iran.liara.space/FinalInvestment.pdf'>Download</Link>
              </div>
            </div>
          </div>
          <div className="catalog">
            <img src={catalogKavir} alt="catalogCover" />
            <div className="catalogContent">
              <div className="catalogContent_top">
                <div className="catalogContent_title">
                  Kavir Steel Complex
                </div>
                <div className="catalogContent_subtitle">
                  You can download our product catalog such as Wire 
                  rod, Steel rebar, Galvanized wire, Galvanized products
                  and see details
                </div>
              </div>
              <div className="catalogContent_Button">
                <Link target='_blank' to='https://tfmenu.storage.iran.liara.space/general%20catalog_230804_205928.pdf'>Download</Link>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="catalog">
            <img src={catalogCg} alt="catalogCover" />
            <div className="catalogContent">
              <div className="catalogContent_top">
                <div className="catalogContent_title">
                  EP Industrial cooler
                </div>
                <div className="catalogContent_subtitle">
                  EP Industrial cooler <br/>
                  Model : PT500A
                </div>
              </div>
              <div className="catalogContent_Button">
                <Link to='https://tfmenu.storage.iran.liara.space/EPIndustrialCooler.pdf'>Download</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
